// +----------------------------------------------------------------------
// | 前端入口：挂载 React + 引入全局样式
// +----------------------------------------------------------------------
import { createRoot } from 'react-dom/client';
import App from './App';
import './css/global.less';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<App />);

// 注意：这里【不能】删 index.html 里的 #boot 启动层！
// 收起时机（最短展示时长 + 淡出动画）由 index.html 内联脚本的 poll 统一控制：
// 它检测 #root 挂载后才收。在这里秒删会绕过全部时长逻辑（2026-09-30 踩坑：
// ?boot=1 的 3 秒开屏不到 1 秒就消失，根因就是这段老骨架时代的秒删代码）。
